const inspirationSlideList = {
    inspirations: [
        {
            name: 'White Romance',
            img: '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/white-romance.jpg'
        },
        {
            name: 'Caribbean Breeze',
            img: '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/caribbean-breeze.jpg'
        },
        {
            name: 'Signature Statement',
            img: '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/signature-statement.jpg'
        },
        {
            name: 'Island Chic',
            img: '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/island-chic.jpg'
        },
        {
            name: 'Love is in Bloom',
            img: '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/love-is-in-bloom.jpg'
        },
        {
            name: 'Modern Love',
            img: '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/modern-love.jpg'
        }
    ]
};

module.exports = inspirationSlideList;
